import React from "react";
import { t } from "i18next";

import type { TaskStatuses } from "api/services/tasks/models";

interface INotificationStatusProps {
    status: TaskStatuses,
    progress?: number
}

const stylesByNotificationType = (type: string) => {
    switch (type) {
        case "COMPLETED":
        case "PARTIAL_COMPLETED": return "text-white bg-green-500";
            break;

        case "FAILED": return "text-white bg-red-600";
            break;

        case "IN_PROCESS": return "text-white bg-yellow-400";
            break;

        case "CREATED":
        case "WAITING":
        case "CANCELLED":
            return "border border-c-gray text-c-blue dark:text-c-gray bg-c-light-gray dark:bg-c-light-black"
            break;

        default: return "text-black"
    }
}

const NotificationStatus: React.FC<INotificationStatusProps> = ({ status, progress }) => {

    return (
        <div className={`${stylesByNotificationType(status)} text-[11px] text-center px-1.5 rounded-full mr-1 break-words whitespace-normal`}>
            {t<string>(status)} {status === "IN_PROCESS" && `${progress}%`}
        </div>
    )

}

export default NotificationStatus;